import { createTheme } from "@mui/material";

const defaultTheme = createTheme();

export const customTheme = {
  ...defaultTheme,
  typography: {
    ...defaultTheme.typography,
    body1: {
      ...defaultTheme.typography.body1,
      fontFamily: "Poppins",
      color: "#ffffff",
    },
  },
};
